import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_API_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_API_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_API_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_API_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_API_FIREBASE_APP_ID,
};

const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();

const firebaseDatabase = app.firestore();

export { firebaseDatabase };